import React from 'react';
import _ from 'lodash';
import {
  Select,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

const TrackerDropDown = (props) => {
  const {trackers, handleChange, currentTracker} = props;

  const TEXT = "Select a funding opportunity"

  let options = trackers
    ? trackers.map((result) => ({
        key: result.trackerId,
        text: result.name,
        value: result.trackerId,
      }))
    : null;

  return (
    <Select
      options={options}
      handleChange={(e) => {handleChange(e.target.value)}}
      id="content"
      target="_self"
      text={TEXT}
      placeholder={TEXT}
      title={TEXT}
      name={TEXT}
      value={currentTracker}
      className={'Tracker-FO-select'}
    />
  );
};

export default TrackerDropDown;
